import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../ReviewPage/ReviewPage.css";
import star from "../../ReviewPage/star.png";

function AfterReviewPage({ activeTab }) {
  const [product, setProduct] = useState(null);
  const [review, setReview] = useState({ rating: 5, text: "" });
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (activeTab === 12) {
      loadLastDeliveredProduct();
    }
  }, [activeTab]);

  const loadLastDeliveredProduct = async () => {
    setLoading(true);
    try {
      // 1. Get orders and find last delivered one
      const { data: orders } = await axios.get(
        "https://dehleze.shop/account/create-order/"
      );
      const deliveredOrders = orders
        .filter((o) => o.order_status?.toLowerCase() === "delivered")
        .reverse(); // latest first

      if (!deliveredOrders.length) return setProduct(null);

      const lastOrder = deliveredOrders[0];

      // 2. Get product info directly (only 1 product)
      const { data: allProducts } = await axios.get(
        "https://dehleze.shop/product-create"
      );
      const matchedProduct = allProducts.find(
        (p) =>
          p.status?.toLowerCase() === "approved" && p.id === lastOrder.product
      );

      if (matchedProduct) {
        setProduct(matchedProduct);
        setReview({ rating: 5, text: "" });
        loadProductReviews(matchedProduct.id);
      } else {
        setProduct(null);
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const loadProductReviews = async (productId) => {
    try {
      const { data } = await axios.get("https://dehleze.shop/reviews/");
      const filtered = data.filter((r) => r.product === productId);
      setReviews(filtered);
    } catch (err) {
      console.error("Error loading reviews", err);
    }
  };

  const handleStarClick = (rating) => {
    setReview((prev) => ({ ...prev, rating }));
  };

  const handleSubmit = async () => {
    if (!review.text.trim()) {
      alert("Please write something.");
      return;
    }

    try {
      await axios.post(
        "https://dehleze.shop/reviews/",
        {
          product: product.id,
          rating: review.rating,
          text: review.text,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      alert("Review submitted!");
      setReview({ rating: 5, text: "" });
      loadProductReviews(product.id);
    } catch (err) {
      console.error("Submit error:", err);
      alert("Failed to submit review.");
    }
  };

  const getImage = (url) =>
    url?.startsWith("http") ? url : `https://dehleze.shop${url}`;

  return activeTab !== 12 ? null : (
    <div className="afterReviewPage">
      <h2>Your Last Delivered Product</h2>

      {loading ? (
        <p>Loading...</p>
      ) : !product ? (
        <p>No delivered products found.</p>
      ) : (
        <div
          style={{
            border: "1px solid #ccc",
            padding: 10,
            borderRadius: 8,
          }}
        >
          <h3>{product.title}</h3>
          <img
            src={getImage(product.product_image)}
            alt={product.title}
            style={{ width: 150, height: 150, objectFit: "cover" }}
          />
          <p>Price: Rs. {product.price}</p>

          <div style={{ marginTop: 10 }}>
            <label style={{ marginRight: 10 }}>Rating:</label>
            {[1, 2, 3, 4, 5].map((n) => (
              <img
                key={n}
                src={star}
                alt={`${n} star`}
                onClick={() => handleStarClick(n)}
                style={{
                  width: 25,
                  height: 25,
                  cursor: "pointer",
                  marginRight: 5,
                  filter: n <= review.rating ? "none" : "grayscale(100%)",
                }}
              />
            ))}
          </div>

          <textarea
            value={review.text}
            onChange={(e) =>
              setReview((prev) => ({ ...prev, text: e.target.value }))
            }
            placeholder="Write your review..."
            style={{ width: "100%", marginTop: 10, minHeight: 80 }}
          />

          <button
            onClick={handleSubmit}
            style={{
              marginTop: 10,
              padding: "6px 12px",
              background: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Submit Review
          </button>

          <div style={{ marginTop: 20 }}>
            <h4>Reviews:</h4>
            {reviews.length === 0 ? (
              <p>No reviews yet.</p>
            ) : (
              reviews.map((r) => (
                <div
                  key={r.id}
                  style={{
                    display: "flex",
                    gap: 10,
                    border: "1px solid #eee",
                    padding: 10,
                    borderRadius: 6,
                    marginBottom: 10,
                    background: "#f9f9f9",
                  }}
                >
                  <img
                    src={getImage(product.product_image)}
                    alt="product"
                    style={{
                      width: 60,
                      height: 60,
                      objectFit: "cover",
                      borderRadius: 4,
                    }}
                  />
                  <div>
                    <div>
                      {Array.from({ length: 5 }).map((_, i) => (
                        <img
                          key={i}
                          src={star}
                          alt="star"
                          style={{
                            width: 18,
                            height: 18,
                            filter: i < r.rating ? "none" : "grayscale(100%)",
                          }}
                        />
                      ))}
                    </div>
                    <p>{r.text}</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default AfterReviewPage;
